// 지식베이스 세 탭이 같이 쓰는 작은 조각(시안 armDelete·dateBox·docIcon·bindDrop).
import { useEffect, useRef, useState } from "react";
import { kstFull } from "../../inquiry/view";

export const nf = (n) => Number(n || 0).toLocaleString("ko-KR");
export const day = (iso) => kstFull(iso).slice(0, 10);
export const mb = (bytes) => `${(Number(bytes || 0) / 1048576).toFixed(2)} MB`;

export function docIcon(name) {
    const e = String(name || "").split(".").pop().toLowerCase();
    if (e === "pdf") return ["fa-file-pdf", "#dc2626"];
    if (e === "doc" || e === "docx") return ["fa-file-word", "#2563eb"];
    if (e === "hwp") return ["fa-file-lines", "#0f766e"];
    return ["fa-file-lines", "#6b7280"];
}

export function useDebounced(value, ms = 300) {
    const [v, setV] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setV(value), ms);
        return () => clearTimeout(t);
    }, [value, ms]);
    return v;
}

// 두 번 눌러야 실행되는 삭제 버튼. 3초 지나면 원래 모양으로.
export function ArmButton({ armedLabel, onConfirm, children, disabled, ...rest }) {
    const [armed, setArmed] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const click = (e) => {
        e.stopPropagation();
        if (disabled) return;
        if (armed) {
            clearTimeout(timer.current);
            setArmed(false);
            onConfirm();
            return;
        }
        setArmed(true);
        timer.current = setTimeout(() => setArmed(false), 3000);
    };
    return <button type="button" {...rest} disabled={disabled} onClick={click}>{armed ? armedLabel : children}</button>;
}

export function DateBox({ from, to, onChange }) {
    return (
        <span className="dbox" title="등록일로 거르기">
            <i className="fa-regular fa-calendar"></i>
            <input type="date" className="inp" aria-label="등록일 시작" value={from} onChange={(e) => onChange(e.target.value, to)} />
            <span>~</span>
            <input type="date" className="inp" aria-label="등록일 끝" value={to} onChange={(e) => onChange(from, e.target.value)} />
            {(from || to) && (
                <button type="button" className="btn btn-sm btn-ghost" title="기간 지우기" onClick={() => onChange("", "")}><i className="fa-solid fa-xmark"></i></button>
            )}
        </span>
    );
}

// 끌어 놓기 + 클릭해서 고르기. 시안 .drop 상자.
export function DropZone({ className = "drop", style, accept, multiple, busy, onFiles, children }) {
    const [over, setOver] = useState(false);
    const input = useRef(null);
    const pick = () => { if (input.current) { input.current.value = ""; input.current.click(); } };
    const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
    return (
        <div
            className={`${className}${over ? " over" : ""}${busy ? " busy" : ""}`}
            style={style}
            onClick={pick}
            onDragEnter={(e) => { stop(e); setOver(true); }}
            onDragOver={(e) => { stop(e); setOver(true); }}
            onDragLeave={(e) => { stop(e); setOver(false); }}
            onDrop={(e) => { stop(e); setOver(false); onFiles([...(e.dataTransfer?.files || [])]); }}
        >
            <input ref={input} type="file" hidden accept={accept} multiple={multiple}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => onFiles([...(e.target.files || [])])} />
            {children(pick)}
        </div>
    );
}
